<script>
    import {M} from "../../external";

    export let data;

    export const LEFT = 1;
    export const RIGHT = 2;

    export function get() {
        return data;
    }
</script>
<div class="col20 f-left email-section-description t-center mt-10 mb-25">{M.PICK_BRANCH}</div>
<div class="col20 flex f-left t-center justify-center">
    <a class="addon-select half-select" class:selected={data === LEFT}
       on:click={() => data = LEFT} style="max-width: 300px;">
        <div class="col20 f-left t-center mb-15">
            <span class="material-icons-outlined fingerprint-icon" style="font-size: 26px;"> subdirectory_arrow_left </span>
        </div>
        <h4 class="col20 f-left mt-25">{M.LEFT}</h4>
    </a>
    <a class="addon-select half-select" class:selected={data === RIGHT}
       on:click={() => data = RIGHT} style="max-width: 300px;">
        <div class="col20 f-left t-center mb-15">
            <span class="material-icons-outlined fingerprint-icon" style="font-size: 26px;"> subdirectory_arrow_right </span>
        </div>
        <h4 class="col20 f-left mt-25">{M.RIGHT}</h4>
    </a>
</div>